export default "__VITE_ASSET__54c01c16__"